module.exports = __webpack_public_path__ + "static/media/Plain-Delivery-Rocket-Distributors-bg.da4aa6df.jpg";